import Box from '@mui/material/Box'
import Fade from '@mui/material/Fade'
import Modal from '@mui/material/Modal'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'
import styles from './BackgroundModal.module.scss'

export default function BackgroundModal({
  children,
  openModal,
  setOpenModal,
  showClose = true,
  closeOnBackdrop = true,
}) {
  const { t } = useTranslation('common')

  const handleClose = (_, reason) => {
    if (reason === 'backdropClick' && !closeOnBackdrop) return
    setOpenModal(false)
  }

  return (
    <div>
      <Modal
        aria-labelledby="bg-modal-title"
        aria-describedby="bg-modal-description"
        open={openModal}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={openModal}>
          <Box
            sx={{
              height: '100vh',
              width: '100vw',
              position: 'fixed',
              top: 0,
              left: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <div
              className={styles.modal_wrapper}
              role="dialog"
              aria-modal="true"
            >
              {showClose ? (
                <IconButton
                  onClick={() => setOpenModal(false)}
                  aria-label={t('ui.close_aria', 'Закрыть')}
                  size="small"
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    zIndex: 1,
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              ) : null}
              {children}
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  )
}
